// Golf 5 (0044; docs/juridisch/notitie-voor-jurist.md §5 G9 en G12). Twee onderdelen:
//  - `childConsent`: toestemming van een ouder voor een kind onder 16, voor een eigen login en voor
//    een foto als avatar (Gezin › lid bewerken). De teksten `login.text`, `login.check`,
//    `photo.text` en `photo.check` zijn de toestemmingstekst: wie ze wijzigt, maakt een nieuwe
//    CHILD_CONSENT_VERSION met een nieuwe hash (packages/domain/src/privacy/childConsent.ts; de test
//    in apps/api herberekent hem).
//  - `privacyStatement`: de pagina /privacy met de volledige privacyverklaring (concept).
// Toon: je-vorm, korte zinnen, B1; wat meteen gebeurt, staat er eerlijk.
export const appChildConsentNl = {
    /** Gelijk aan CHILD_CONSENT_VERSION (packages/domain). */
    version: '2026-09-26.1',
    title: 'Toestemming voor {name}',
    intro: '{name} is jonger dan 16. Voor een eigen login of een foto vragen we eerst toestemming van een ouder.',
    notNeeded: '{name} is 16 of ouder en beslist zelf over een eigen login en een foto.',
    login: {
        title: 'Eigen login',
        text: 'Met een eigen login kan {name} zelf inloggen in de app, op een telefoon of computer. {name} ziet dan de eigen agenda, taken, punten en berichten van het gezin, maar nooit toestemmingen, e-mailadressen of gezondheid. AMUMIN B.V. bewaart wie de toestemming gaf, wanneer en welke tekst je las. Intrekken kan altijd: de login werkt dan meteen niet meer.',
        check: 'Ik ben ouder of voogd van {name} en geef toestemming voor een eigen login.',
    },
    photo: {
        title: 'Foto als avatar',
        text: 'Met toestemming kun je een foto van {name} gebruiken in plaats van een pictogram. De foto staat dan in de app en op het bord aan de muur: iedereen in de kamer met de tablet ziet hem. We halen de plaats en andere gegevens uit de foto en delen hem met niemand. AMUMIN B.V. bewaart wie de toestemming gaf, wanneer en welke tekst je las. Intrekken kan altijd: de foto is dan meteen weg.',
        check: 'Ik ben ouder of voogd van {name} en geef toestemming voor een foto.',
    },
    /** Knop die de tekst en het vinkje laat zien. */
    ask: 'Toestemming geven',
    give: 'Geef toestemming',
    cancel: 'Niet nu',
    withdraw: 'Intrekken',
    withdrawConfirm: 'Ja, intrekken',
    withdrawLogin: 'Toestemming voor de eigen login intrekken? De login van {name} werkt dan meteen niet meer.',
    withdrawPhoto: 'Toestemming voor de foto intrekken? De foto van {name} is dan meteen weg.',
    none: 'Nog geen toestemming',
    givenBy: 'Toestemming van {name} op {date}',
    givenByYou: 'Jouw toestemming op {date}',
    givenOn: 'Toestemming op {date}',
    hasLogin: '{name} heeft nu een eigen login.',
    hasPhoto: '{name} heeft nu een foto.',
    given: 'Toestemming gegeven',
    withdrawn: 'Toestemming ingetrokken',
    withdrawnLogin: 'De login van {name} werkt niet meer.',
    withdrawnPhoto: 'De foto van {name} is weg.',
    checkRequired: 'Zet eerst het vinkje.',
    privacyLink: 'Meer in de privacyverklaring',
    /** Review g5 sec r2: een kindlogin van vóór 0044 zonder toestemming. */
    loginWithoutConsent: '{name} heeft al een login zonder toestemming: geef toestemming of zet de login uit.',
    disableLogin: 'Login uitzetten',
    disableLoginAsk: 'De login van {name} uitzetten? Die werkt dan meteen niet meer.',
    disableLoginConfirm: 'Ja, uitzetten',
    loginDisabled: 'De login van {name} staat uit.',
    /** Gezin: de lijst met zulke kinderen (namen eronder). */
    missingList: 'Deze kinderen hebben al een login zonder toestemming: geef toestemming of zet de login uit.',
    /** 409 van de toestemmingspoort (0044) bij het wijzigen van een lid. */
    gateLogin: 'Deze persoon heeft een eigen login. Een kind onder 16 heeft eerst toestemming van een ouder nodig: haal eerst de login weg, pas dan de leeftijd aan en geef daarna toestemming.',
    gatePhoto: 'Een foto van een kind onder 16 kan alleen met toestemming van een ouder. Geef eerst toestemming of haal de foto weg.',
};
export const appPrivacyStatementNl = {
    title: 'Privacyverklaring',
    back: 'Terug naar de app',
    /** Duidelijk bovenaan: dit is nog geen definitieve tekst. */
    concept: 'Concept, wordt juridisch nagekeken',
    version: 'Versie {version} · {date}',
    contents: 'Inhoud',
    /** Voor talen zonder eigen vertaling: één zin in die taal, daarna de Nederlandse tekst. */
    onlyDutch: 'Deze privacyverklaring is er nog niet in jouw taal. Hieronder staat de Nederlandse tekst; je kunt ook Engels kiezen.',
    showDutch: 'Nederlands',
    showEnglish: 'English',
    /** Zin bij een nog in te vullen stuk ("[adres]"). */
    placeholder: 'nog in te vullen',
};
//# sourceMappingURL=golf5App.nl.js.map